
import { dialog } from "./categories/dialog";
import { embedding } from "./categories/embedding";
import { featureManagement } from "./categories/feature-management";
import { navigation } from "./categories/navigation";
import { playback } from "./categories/playback";
import { speedTesting } from "./categories/speed-testing";
import { tracking } from "./categories/tracking";
import { uiActions } from "./categories/ui-actions";
import { userAccount } from "./categories/user-account";
import { userProfile } from "./categories/user-profile";
import { videoContent } from "./categories/video-content";
import { VisualElements } from "./categories/visual-elements";
import { autoplayOverlay, salesNotification } from "./categories/autoplay-overlay";
import { pagesEn } from "./categories/pages-en";

// Translations for US English
export const en = {
  ...dialog,
  ...embedding,
  ...featureManagement,
  ...navigation,
  ...playback,
  ...speedTesting,
  ...tracking,
  ...uiActions,
  ...userAccount,
  ...userProfile,
  ...videoContent,
  ...VisualElements,
  ...autoplayOverlay,
  ...salesNotification,
  ...pagesEn,
};
